import { Icon } from "src/components/ui/icons/Icon";

export const meta = {
  title: "Tutorials"
};

# Tutorials
<Box className="doc-width-full">
<DocNavTileGrid>
	<DocNavTile docId="tutorials/read-this-first" icon={<Icon icon="wolf" />} >
		<h3>A Preface by Adana</h3>
		Hello World
	</DocNavTile>
  <DocNavTile docId="tutorials/data-types" icon={<Icon icon="terminal" />} >
		<h3>Data Types</h3>
		Learn how JavaScript represents information
	</DocNavTile>
  <DocNavTile docId="tutorials/operators" icon={<Icon icon="terminal" />} >
		<h3>Operators</h3>
		Learn how to perform math and logic on data
	</DocNavTile>
  <DocNavTile docId="tutorials/control-flow" icon={<Icon icon="terminal" />} >
		<h3>Control Flow</h3>
		Set up conditions, loops, and functions 
	</DocNavTile>
</DocNavTileGrid>
</Box>
